export function FlechaIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 138.9 137.8"
      className={`inline-block h-[0.7em] w-[0.7em] align-middle ${className}`}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M113.9,133.4h25l-.8-133.4H24.4v25.1h60.6c-2.2,7.2-5.5,14.3-9.9,21.3C56.2,72.7,31.8,87.2,1.9,89.9H0c.3,16,0,31.9.3,47.9.6,0,1.2,0,1.8,0,0,0,0,0,0-.1,0-.2,0-.4,0-.7,24.5-2,48.8-9,70.9-22.6,17.6-12.4,31.5-26.2,41.8-41.3-.5,11-1,19.1-1,19.1v41.2h0Z"
      />
    </svg>
  );
}
